import capitalize from 'lodash/capitalize';

import {
  ChoiceChipV2,
  Divider,
  Input,
  Stack,
  withProps,
} from '@cast/design-system';

import { QuickSearch, QuickSearchGroup } from '@cast/shared-search-ui';

const StyledDivider = withProps(Divider, {
  orientation: 'vertical',
  color: 'grey.300',
  sx: { mx: 4, height: 24, alignSelf: 'flex-end' },
});

type Props = {
  domainOptions: string[];
  severityOptions: string[];
  search: string;
  onSearchChange: (value: string) => void;
  selectedDomain: string | null;
  onDomainChange: (value: string | null) => void;
  selectedSeverity: string | null;
  onSeverityChange: (value: string | null) => void;
};

export const CatalogueFilters = ({
  domainOptions,
  severityOptions,
  search,
  onSearchChange,
  selectedDomain,
  onDomainChange,
  selectedSeverity,
  onSeverityChange,
}: Props) => {
  return (
    <Stack gap="16px" mb="20px">
      <Stack direction="row" gap="8px" alignItems="center" flexWrap="wrap">
        <Stack flexGrow={1} minWidth={300}>
          <Input
            placeholder="Enter search keywords here"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            testId="catalogue-search"
          />
        </Stack>
      </Stack>

      <QuickSearch defaultOpen>
        <QuickSearchGroup label="Domain">
          {domainOptions.map((domain) => (
            <ChoiceChipV2
              key={domain}
              label={domain}
              selected={selectedDomain === domain}
              onClick={() =>
                onDomainChange(selectedDomain === domain ? null : domain)
              }
              testId={`catalogue-domain-${domain}`}
            />
          ))}
        </QuickSearchGroup>
        <StyledDivider />
        <QuickSearchGroup label="Severity">
          {severityOptions.map((severity) => (
            <ChoiceChipV2
              key={severity}
              label={capitalize(severity)}
              selected={selectedSeverity === severity}
              onClick={() =>
                onSeverityChange(
                  selectedSeverity === severity ? null : severity
                )
              }
              testId={`catalogue-severity-${severity}`}
            />
          ))}
        </QuickSearchGroup>
      </QuickSearch>
    </Stack>
  );
};
